/**
 * Lazily load decor-item hover images on first interaction.
 */
function loadDecorHoverImage(img) {
    if (!img?.dataset?.src) {
        return;
    }

    img.src = img.dataset.src;

    if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
    }

    delete img.dataset.src;
    delete img.dataset.srcset;
}

document.addEventListener('pointerenter', (event) => {
    const item = event.target.closest?.('.c-decor-item');

    if (!item) {
        return;
    }

    const hoverImg = item.querySelector('.c-decor-item__image--hover[data-src]');
    loadDecorHoverImage(hoverImg);
}, true);
